<template>
    <div class="row padding_form center padding-bottom">
        <div class="col-md-6 offset-md-3">
            <img :src="require('@/assets/images/cadeado.png')" width="20"><br>
            <b>SITE 100% SEGURO</b><br>
            Associação Regina Fidei - 2025 | Todos os direitos Reservados
        </div>
    </div>
</template>